export const CATEGORIES = {
  PHYSICAL_PRODUCT: 'physical_product'
}

export const verifyIfIsAPhysicalProduct = (category: string) =>
  category.includes(CATEGORIES.PHYSICAL_PRODUCT)
